import { request } from "@/utils/request.js";

//获取项目默认信息报表，统计各个月份的项目数
export function getProjectFormDefaultListAPI() {
  return request({
    url: `/crostars-form/get-project-form-default`,
    method: 'GET',
  })
}

//获取项目信息报表，通过日期统计各个月份的项目数
export function getProjectFormListAPI(startTime, endTime) {
  return request({
    url: `/crostars-form/get-project-form?startTime=${startTime}&endTime=${endTime}`,
    method: 'POST',
  })
}